import * as React from 'react';
import * as styled from './styled';
import Button, {ButtonVariant} from 'components/Button';
import {BlocksGroupProps} from './types';

/**
 * The group of blocks in the task.
 * @param {BlocksGroupProps} props
 * @return {React.ReactElement<BlocksGroupProps>}
 * @constructor
 */
export default function BlocksGroup(
    props: BlocksGroupProps,
): React.ReactElement<BlocksGroupProps> {
  /**
   * Render totals.
   * @return {JSX.Element}
   */
  function renderTotals(): JSX.Element {
    /**
     * Render tasks.
     * @return {JSX.Element}
     */
    function renderTasks(): JSX.Element {
      /**
       * Get task count.
       * @return {number}
       */
      function getTasksCount(): number {
        return props.content.blocks.length;
      }

      return (
        <styled.Total>
          Вы ответили на <span>{`0 / ${getTasksCount()} вопросов`}</span>
        </styled.Total>
      );
    }

    /**
     * Render time.
     * @return {JSX.Element}
     */
    function renderTime(): JSX.Element {
      return (
        <styled.Total>
          На прохождение: <span>1 ч 30 м 0 с</span>
        </styled.Total>
      );
    }

    /**
     * Render score.
     * @return {JSX.Element}
     */
    function renderScore(): JSX.Element {
      /**
       * Get total score.
       * @return {number}
       */
      function getTotalScore(): number {
        return props.content.blocks.reduce((total, current) => {
          return total + current.score;
        }, 0);
      }

      return (
        <styled.Total>
          Баллы: <span>{`0 / ${getTotalScore()}`}</span>
        </styled.Total>
      );
    }

    /**
     * Render attempts.
     * @return {JSX.Element}
     */
    function renderAttempts(): JSX.Element {
      return (
        <styled.Total>
          Попытки: <span>0/3</span>
        </styled.Total>
      );
    }

    return (
      <styled.Totals>
        {renderTasks()}
        {/* renderTime() */}
        {renderScore()}
        {/* renderAttempts() */}
      </styled.Totals>
    );
  }

  /**
   * Render button.
   * @return {JSX.Element}
   */
  function renderButton(): JSX.Element {
    /**
     * Get the button label.
     * @return {string}
     */
    function getLabel(): string {
      if (props.isViewed) {
        return 'Просмотрено';
      } else {
        if (props.isStarted) {
          return 'Продолжить';
        } else {
          return 'Начать';
        }
      }
    }

    /**
     * Get the button variant.
     * @return {ButtonVariant}
     */
    function getVariant(): ButtonVariant {
      if (props.isViewed) {
        return ButtonVariant.Outline;
      } else {
        return ButtonVariant.Primary;
      }
    }

    return (
      <Button type="button" variant={getVariant()}>
        {getLabel()}
      </Button>
    );
  }

  return (
    <styled.Wrapper>
      {renderTotals()}
      {renderButton()}
    </styled.Wrapper>
  );
}
